<template>
  <!-- 订单历史数据 -->
  <a-layout-content>
    <div>
      <a-form layout="inline">
        <a-form-item label="会员账号">
          <a-input v-model="input.User" />
        </a-form-item>
        <a-form-item label="订单类型">
          <a-select v-model="input.Type" :disabled="disable" style="width: 120px">
            <a-select-option value="0"> 全部</a-select-option>
            <a-select-option value="1"> 借款</a-select-option>
            <a-select-option value="2"> 还款</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="状态">
          <a-select v-model="input.Status" :disabled="disable" style="width: 120px">
            <a-select-option value="0"> 全部</a-select-option>
            <a-select-option value="2"> 审核成功</a-select-option>
            <a-select-option value="3"> 审核失败</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="查询类型">
          <a-select @change="changeSelect" v-model="input.Selecttype" style="width: 186px">
            <a-select-option value="1"> 历史订单</a-select-option>
            <a-select-option value="2"> 逾期借款</a-select-option>
            <a-select-option value="3"> 未逾期借款</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="时间范围">
          <a-range-picker :default-value="[moment().startOf('week'), moment().endOf('week')]" show-time
            :format="dateFormat" :ranges="dataRange" @change="onChange" />
        </a-form-item>
        <a-form-item v-if="role86">
          <a-button type="primary" @click="query()"><a-icon type="search" /></a-button>
        </a-form-item>
        <a-form-item v-if="role87">
          <a-button type="primary" @click="orderexport()">
            <a-icon type="file-excel"></a-icon>
            <span style="font-size: 15px">导出数据</span>
          </a-button>
        </a-form-item>
        <a-form-item>
          <a-button type="danger" @click="jiebeidataRecovery()">
            <a-icon type="file-excel"></a-icon>
            <span style="font-size: 15px">借呗数据修复</span>
          </a-button>
        </a-form-item>
      </a-form>
    </div>
    <br />
    <a-table bordered size="small" row-key="ID" :row-selection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
      }" :loading="loading" :columns="columns" :data-source="datarow" :pagination="pagination" @change="changepage">
      <template slot="title">
        <a-row :gutter="24">
          <a-col style="float: left">
            <template v-if="role89">
              <a href="javascript:;" @click="BatchShow(true)">
                <a-icon type="check" style="font-size: 22px"></a-icon>
                <span style="font-size: 15px">批量显示</span>
              </a>
              &nbsp; &nbsp;
              <a href="javascript:;" @click="BatchShow(false)">
                <a-icon type="close" style="font-size: 22px"></a-icon>
                <span style="font-size: 15px">批量不显示</span>
              </a>
            </template>
          </a-col>
        </a-row>
      </template>
      <template slot="User" slot-scope="text, record">
        <a @click="UserRoute(record.User)">{{ text }}</a>
      </template>
      <template slot="Type" slot-scope="text">
        <span v-if="text == 1" style="color: green">借款</span>
        <span v-if="text == 2" style="color: red">还款</span>
      </template>
      <template slot="Status" slot-scope="text">
        <span v-if="text == 1">待审核</span>
        <span v-if="text == 2" style="color: green">审核成功</span>
        <span v-if="text == 3" style="color: red">审核失败</span>
      </template>
      <template slot="Money" slot-scope="text, record">
        <span v-if="record.Type == 1">{{ text }}</span>
        <span v-if="record.Type == 2">{{ text }}</span>
      </template>
      <template slot="Day" slot-scope="text, record">
        <span v-if="record.Type == 1">{{ text }}</span>
        <span v-if="record.Type == 2">-</span>
      </template>
      <template slot="Fdt" slot-scope="text, record">
        <span>时间: {{ transDateFormat(text, 0) }}</span>
        <span v-if="record.Type == 1"><br />到期: {{ transDateFormat(text, record.Day) }}</span>
      </template>
      <template slot="Ldt" slot-scope="text">
        <span>{{ transDateFormat(text, 0) }}</span>
      </template>
      <template slot="Show" slot-scope="text, record">
        <a-switch checked-children="" un-checked-children="" v-model="record.Show"
          @change="(value) => swichShow(value, record)" />
      </template>
      <template slot="Memo" slot-scope="text">
        <span>{{ text }}</span>
      </template>
      <template slot="ImageUrlRender" slot-scope="text, record" v-if="role86">
        <template v-if="record.ImageUrl != ''">
          <a-tooltip>
            <template slot="title">查看交易截图</template>
            <a href="javascript:;" @click="onIamge(record.ImageUrl)">
              <a-icon type="file-image" style="font-size: 22px"></a-icon>
            </a>
          </a-tooltip>
        </template>
      </template>
      <template slot="Operation" slot-scope="text, record" v-if="role90">
        <a-tooltip title="编辑">
          <a @click="showeditMemo(record)">
            <a-icon type="edit" style="font-size: 22px"></a-icon>
          </a>
        </a-tooltip>
      </template>

    </a-table>

    <!--------------------------------------------------弹窗部份-------------------------------------------------->
    <a-modal v-model="visible" title="编辑" width="40%" ok-text="储存" cancel-text="取消" @ok="editMemo" layout="inline">
      <a-form-model :model="formMemo" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="状态">
          <a-select v-model="formMemo.Status">
            <a-select-option value="2"> 审核通过</a-select-option>
            <a-select-option value="3"> 审核未通过</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="天数" v-if="formMemo.Type == '1'">
          <a-input-number v-model="formMemo.BorrowDay" :min="0" :max="1000" :formatter="(value) => `${value} 天`" />
        </a-form-model-item>
        <a-form-model-item label="备注">
          <a-textarea v-model="formMemo.Memo" :rows="12" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!--------------------------------------------------弹窗部份-------------------------------------------------->
  </a-layout-content>
</template>
<script>
  import moment from "moment";
  import template from "../template.vue";

  export default {
    components: { template },
    data() {
      return {
        /*** 权限
         86	历史订单数据查询
          87	历史订单导出数据
          88	历史订单数据显示
          89	历史订单数据批量显示
          90	历史订单数据编辑
         */
        role86: false,
        role87: false,
        role88: false,
        role89: false,
        role90: false,
        dataRange,
        dateFormat: "YYYY-MM-DD HH:mm:ss",
        datarow: [],
        columns: IninTable(),
        pagination: {
          total: 0,
          pageindex: 1,
          pagesize: 10,
          showTotal: (total) => `共 ${total} 条`,
          showSizeChanger: true, // 可以改变每页个数
          pageSizeOptions: ["10", "50", "500", "5000", "10000"],
          onShowSizeChange: (current, pageSize) => (this.pageSize = pageSize),
        },
        selectedRowKeys: [],
        selectedRowOrderid: [],
        loading: false,
        visible: false,
        disable: false,
        input: {
          User: "",
          Type: "0",
          Status: "0",
          Sdt: "",
          Edt: "",
          Selecttype: "1",
        },
        labelCol: { span: 5 },
        wrapperCol: { span: 14 },
        formMemo: { Type: "0", OrderId: "0", Memo: "", Day: "0", BorrowDay: "0", Status: "1" },
      };
    },
    methods: {
      moment,
      //翻页
      changepage(e) {
        this.pagination.pageindex = e.current;
        this.pagination.pagesize = e.pageSize;
        this.query();
      },
      // 查询时间绑定
      onChange(value, dateString) {
        this.input.Sdate = dateString[0];
        this.input.Edate = dateString[1];
      },
      onSelectChange(selectedRowKeys, selectRows) {
        this.selectedRowKeys = selectedRowKeys;
        this.selectedRowOrderid = [];
        selectRows.forEach((element) => {
          let json = {};
          json["Type"] = element.Type;
          json["Orderid"] = element.OrderId;
          this.selectedRowOrderid.push(json);
        });
      },
      transDateFormat(val, day) {
        let dateTime = new Date(val);
        dateTime = dateTime.setDate(dateTime.getDate() + day);
        let time = this.getDate(dateTime, "yyyy-MM-dd HH:mm:ss");

        return time;
      },
      changeSelect() {
        if (this.input.Selecttype == "2" || this.input.Selecttype == "3") {
          this.input.Status = "2";
          this.input.Type = "1";
          this.disable = true;
        } else {
          this.input.Status = "0";
          this.input.Type = "0";
          this.disable = false;
        }
        this.query();
      },
      swichShow(e, record) {
        let params = {
          Type: record.Type,
          OrderId: record.OrderId,
          Show: e,
        };

        this.axios
          .post("/usermember/orderhistoryeditshow", params)
          .then((res) => {
            if (res.data) {
              this.$message.success("修改成功!");
            } else {
              this.$message.error(res.error);
            }
          });
      },
      BatchShow(show) {
        let params = {
          Show: show,
          BatchTypeOrderID: this.selectedRowOrderid,
        };

        this.axios
          .post("/usermember/orderhistoryeditbatchshow", params)
          .then((res) => {
            if (res.data) {
              this.$message.success("修改成功!");
              this.query();
            } else {
              this.$message.error(res.error);
            }
          });
      },
      showeditMemo(record) {
        this.visible = true;
        console.log(record)
        this.formMemo.Type = record.Type;
        this.formMemo.OrderId = record.OrderId;
        this.formMemo.Memo = record.Memo;
        this.formMemo.Day = record.Day;
        this.formMemo.BorrowDay = record.BorrowDay;
        this.formMemo.Status = record.Status.toString();
      },
      editMemo() {
        let params = {
          Type: this.formMemo.Type,
          OrderId: this.formMemo.OrderId,
          Memo: this.formMemo.Memo,
          Day: this.formMemo.BorrowDay,
          Status: this.formMemo.Status,
        };
        const that = this;

        this.$confirm({
          title: "修改历史订单",
          content: "您是否确定要修改历史数据吗? 注意!如果有改变状态修复数据时将会影响会员当前未还款及时数据",
          onOk() {
            that.axios
              .post("/usermember/orderhistoryeditmemo", params)
              .then((res) => {
                if (res.data) {
                  that.$message.success("修改成功!");
                  that.query();
                  that.visible = false;
                } else {
                  that.$message.error(res.error);
                }
              });
          },
        });
      },
      query() {
        if (this.input.Sdate === "") {
          this.$message.warning("请选择查询开始时间!");
          return false;
        }
        if (this.input.Edate === "") {
          this.$message.warning("请选择查询结束时间!");
          return false;
        }

        let params = {
          User: this.input.User,
          Type: this.input.Type,
          Status: this.input.Status,
          Selecttype: this.input.Selecttype,
          Sdt: this.input.Sdate,
          Edt: this.input.Edate,
          pageindex: this.pagination.pageindex,
          pagesize: this.pagination.pagesize,
        };
        this.axios.post("/usermember/getorderhistory", params).then((res) => {
          this.datarow = res.data;
          this.pagination.total = res.total;
        });
      },
      jiebeidataRecovery() {
        let params = {
          Type: 1,
        };
        const that = this;

        this.$confirm({
          title: "借呗数据修复",
          content: "您是否确定要修复借呗数据吗? 注意!修复执行会需要一点时间请保持在页面耐心等待",
          onOk() {
            that.axios
              .post("/usermember/jiebeidatarecovery", params)
              .then((res) => {
                if (res.data) {
                  that.$message.success("修复成功!");
                } else {
                  that.$message.error(res.error);
                }
              });
          },
        });
      },
      UserRoute(obj) {
        this.$router.push({
          name: 'user',
          params: {
            name: 'user',
            userid: obj,
          }
        });
      },
      onIamge(data) {
        window.open("https://check.utlkbck.com/image/" + data);
      },
      orderexport() {
        let today = new Date();

        let params = {
          User: this.input.User,
          Type: this.input.Type,
          Status: this.input.Status,
          Selecttype: this.input.Selecttype,
          Sdt: this.input.Sdate,
          Edt: this.input.Edate,
          pageindex: 0,
          pagesize: 0,
        };

        this.axios({
          url: "/usermember/exportorderhistory",
          method: "get",
          params: params,
          responseType: "blob",
        }).then((response) => {
          let blob = new Blob([response.data], { type: response.data.type });
          // 针对于 IE 浏览器的处理, 因部分 IE 浏览器不支持 createObjectURL
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob);
          } else {
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); // 创建下载的链接
            downloadElement.href = href;
            downloadElement.download =
              "历史订单数据- " + today.toISOString().split("T")[0]; // 下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); // 点击下载
            document.body.removeChild(downloadElement); // 下载完成移除元素
            window.URL.revokeObjectURL(href); // 释放掉 blob 对象
          }
        });
      },
    },
    watch: {
      $route(to, from) {
        if (this.$route.params.name === "orderhistory") {
          this.input.User = this.$route.params.userid;
          this.input.Type = this.$route.params.type;
          this.query();
        }
      },
    },
    //首次加载
    created() {
      if (this.$route.params.name === "orderhistory") {
        this.input.User = this.$route.params.userid;
        this.input.Type = this.$route.params.type;
      }
      // 初始化时间
      this.input.Sdate = moment().startOf("week").format(this.dateFormat);
      this.input.Edate = moment().endOf("week").format(this.dateFormat);
      this.query();
      //获取权限
      const array = JSON.parse(sessionStorage.RoleID);
      const roleID = [86, 87, 88, 89, 90];
      var isRole = roleID.filter(function (item) {
        return array.indexOf(item) != -1;
      });
      //功能权限获取
      isRole.forEach((element) => {
        this["role" + element] = true;
      });
    },
  };

  let dataRange = {
    全部: [moment("1911-01-01"), moment()],
    今天: [moment().startOf("day"), moment().endOf("day")],
    昨天: [
      moment().startOf("day").subtract(1, "days"),
      moment().endOf("day").subtract(1, "days"),
    ],
    本周: [moment().startOf("week"), moment().endOf("week")],
    本月: [moment().startOf("month"), moment().endOf("month")],
    最近1个月: [moment().startOf("day").subtract(1, "months"), moment()],
    最近3个月: [moment().startOf("day").subtract(3, "months"), moment()],
    今年: [moment().startOf("years"), moment().endOf("years")],
    去年: [
      moment().startOf("years").subtract(1, "years"),
      moment().endOf("years").subtract(1, "years"),
    ],
  };

  const IninTable = function IninTable() {
    var header = [];

    header.push({ title: "#", align: "center", width: 50, dataIndex: "ID" });
    header.push({
      title: "用户名",
      align: "center",
      dataIndex: "User",
      scopedSlots: { customRender: "User" },
    });
    header.push({ title: "姓名", align: "center", dataIndex: "UserName" });
    header.push({
      title: "类型",
      align: "center",
      dataIndex: "Type",
      scopedSlots: { customRender: "Type" },
    });
    header.push({
      title: "金额",
      align: "center",
      dataIndex: "Money",
      scopedSlots: { customRender: "Money" },
    });
    header.push({
      title: "当前未还款金额",
      align: "center",
      dataIndex: "Over",
      scopedSlots: { customRender: "Over" },
    });
    header.push({
      title: "还款倒数天数",
      align: "center",
      dataIndex: "Day",
      scopedSlots: { customRender: "Day" },
    });
    header.push({
      title: "状态",
      align: "center",
      dataIndex: "Status",
      scopedSlots: { customRender: "Status" },
    });
    header.push({
      title: "时间",
      align: "center",
      dataIndex: "Fdt",
      scopedSlots: { customRender: "Fdt" },
    });
    header.push({
      title: "显示",
      align: "center",
      dataIndex: "Show",
      scopedSlots: { customRender: "Show" },
    });

    header.push({
      title: "备注",
      align: "center",
      dataIndex: "Memo",
      width: 600,
      scopedSlots: { customRender: "Memo" },
    });

    header.push({
      title: "最后修改时间",
      align: "center",
      dataIndex: "Ldt",
      scopedSlots: { customRender: "Ldt" },
    });

    header.push({
      title: "最后修改人",
      align: "center",
      dataIndex: "Editor",
    });

    header.push({
      title: "交易截图",
      align: "center",
      width: 100,
      scopedSlots: { customRender: "ImageUrlRender" },
    });

    header.push({
      title: "操作",
      align: "center",
      width: 50,
      scopedSlots: { customRender: "Operation" },
    });

    return header;
  };
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/ordermanage/orderhistory.vue